declare const siteVars: { ajaxUrl: string };

const btn  = document.getElementById('ps-cat-load-more') as HTMLButtonElement | null;
const grid = document.getElementById('ps-cat-grid') as HTMLElement | null;

if (btn && grid) {
    btn.addEventListener('click', async () => {
        const offset  = parseInt(btn.dataset.offset   ?? '6', 10);
        const perPage = parseInt(btn.dataset.perPage  ?? '3', 10);
        const catId   = btn.dataset.catId  ?? '0';
        const nonce   = btn.dataset.nonce  ?? '';

        btn.disabled    = true;
        btn.textContent = '...';

        try {
            const body = new URLSearchParams({
                action:   'ps_load_more_category',
                nonce,
                cat_id:   catId,
                offset:   String(offset),
                per_page: String(perPage),
            });

            const res  = await fetch(siteVars.ajaxUrl, {
                method:  'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body:    body.toString(),
            });

            const data = await res.json();

            if (data.success) {
                grid.insertAdjacentHTML('beforeend', data.data.html);
                btn.dataset.offset = String(data.data.offset);

                if (!data.data.has_more) {
                    btn.parentElement?.remove();
                } else {
                    btn.disabled    = false;
                    btn.textContent = 'CARREGAR MAIS';
                }
            } else {
                btn.disabled    = false;
                btn.textContent = 'CARREGAR MAIS';
            }
        } catch {
            btn.disabled    = false;
            btn.textContent = 'CARREGAR MAIS';
        }
    });
}
